export default {
	data(){
		return {
			tableGBoptions: { 
				options: {anular: 'Anular exámen'},
				modals: [
					{
					  "modal": "registrar",
					  "icon": "credit-card",
					  "title": "Registrar orden de garantía"
					},
				]
			},

			tableGBSearch: ['datos_pacientes/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nombre', sort: null, sortTable: 'datos_pacientes/name'},
					tbody: { td: ['datos_pacientes/name']}
				},
				{
					thead: { th: 'Direccion', },
					tbody: { td: ['datos_pacientes/direccion'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_pacientes/telefonos'],}
				},
				{
					thead: { th: 'Garantia', },
					tbody: { td: ['info_garantia/garantia'] }
				},
				{
					thead: { th: 'Exámen', },
					tbody: { td: ['info_garantia/id'], link: '/api/pdf/garantia_examen' }
				},
			]						
		}
	},	
}